import type { AdminTenantListFilters } from '@/api/models';

/** Count of active tenant-list filters, for the `FiltersPopover` badge. Excludes pagination. */
export function countActiveTenantFilters(filters: AdminTenantListFilters): number {
  return [filters.q, filters.status?.length].filter((value) => Boolean(value)).length;
}
